import { actionProps } from "../types";
import { isValidPhoneNumber } from "react-phone-number-input";

const removeWhiteSpace = (item: string) => {
  return item.trim();
};

export const checkFormField = (key: string, action: actionProps) => {
  if (key === "title") {
    const { title } = action;
    if (removeWhiteSpace(title) !== "") return false;
    return true;
  } else if (key === "firstName") {
    const { firstName } = action;
    if (removeWhiteSpace(firstName) !== "") return false;
    return true;
  } else if (key === "lastName") {
    const { lastName } = action;
    if (removeWhiteSpace(lastName) !== "") return false;
    return true;
  } else if (key === "phone") {
    const { phone } = action;
    if (phone !== "" && phone !== undefined) {
      if (isValidPhoneNumber(phone)) {
        return false;
      }
      return true;
    }
    return true;
  } else if (key === "degree") {
    const { degree } = action;
    if (removeWhiteSpace(degree) !== "") return false;
    return true;
  } else if (key === "qualifications") {
    const { qualifications } = action;
    if (removeWhiteSpace(qualifications) !== "") return false;
    return true;
  } else if (key === "price") {
    const { price } = action;
    if (price !== "") return false;
    return true;
  } else if (key === "regiNumber") {
    const { regiNumber } = action;
    if (removeWhiteSpace(regiNumber) !== "") return false;
    return true;
  } else if (key === "speciality") {
    const { speciality } = action;
    if (Object.keys(speciality).length !== 0) {
      return false;
    }
    return true;
  } else if (key === "bankName") {
    const { bankName } = action;
    if (removeWhiteSpace(bankName) !== "") return false;
    return true;
  } else if (key === "languages") {
    const { languages } = action;
    if (languages.length !== 0) {
      let result = 0;
      languages.map((language) => {
        if (language.status === true) {
          result = result + 1;
        }
        return result;
      });
      if (result > 0) return false;
      return true;
    }
    return true;
  } else if (key === "timeslot") {
    const { timeslot } = action;
    if (
      (timeslot[0].status === true && timeslot[0].timeslots.length > 0) ||
      (timeslot[1].status === true && timeslot[1].timeslots.length > 0) ||
      (timeslot[2].status === true && timeslot[2].timeslots.length > 0) ||
      (timeslot[3].status === true && timeslot[3].timeslots.length > 0) ||
      (timeslot[4].status === true && timeslot[4].timeslots.length > 0) ||
      (timeslot[5].status === true && timeslot[5].timeslots.length > 0) ||
      (timeslot[6].status === true && timeslot[6].timeslots.length > 0)
    )
      return false;
    return true;
  } else if (key === "branchName") {
    const { branchName } = action;
    if (removeWhiteSpace(branchName) !== "") return false;
    return true;
  } else if (key === "acntHolder") {
    const { acntHolder } = action;
    if (removeWhiteSpace(acntHolder) !== "") return false;
    return true;
  } else if (key === "acntNumber") {
    const { acntNumber } = action;
    if (acntNumber !== 0 && removeWhiteSpace(acntNumber.toString()) !== "") return false;
    return true;
  } else if (key === "signatureImage") {
    const { signatureImage } = action;
    if (removeWhiteSpace(signatureImage) !== "") return false;
    return true;
  } else if (key === "profileImage") {
    const { profileImage } = action;
    if (removeWhiteSpace(profileImage) !== "") return false;
    return true;
  } else if (key === "nicImage") {
    const { nicImage } = action;
    if (removeWhiteSpace(nicImage) !== "") return false;
    return true;
  } else if (key === "sealImage") {
    const { sealImage } = action;
    if (removeWhiteSpace(sealImage) !== "") return false;
    return true;
  } else if (key === "slmcIDImage") {
    const { slmcIDImage } = action;
    if (removeWhiteSpace(slmcIDImage) !== "") return false;
    return true;
  } else if (key === "proofOfQualificationImage") {
    const { proofOfQualificationImage } = action;
    if (removeWhiteSpace(proofOfQualificationImage) !== "") return false;
    return true;
  } else if (key === "termsAndConditions") {
    const { termsAndConditions } = action;
    if (removeWhiteSpace(termsAndConditions) !== "" && termsAndConditions !== "I don’t accept")
      return false;
    return true;
  } else {
    return true;
  }
};
